import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const bannerDefaultVariants = {
  "status": "info"
}
const bannerCompoundVariants = []

const bannerSlotNames = [
  [
    "root",
    "banner__root"
  ],
  [
    "content",
    "banner__content"
  ],
  [
    "action",
    "banner__action"
  ]
]
const bannerSlotFns = /* @__PURE__ */ bannerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, bannerDefaultVariants, getSlotCompoundVariant(bannerCompoundVariants, slotName))])

const bannerFn = memo((props = {}) => {
  return Object.fromEntries(bannerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const bannerVariantKeys = [
  "status"
]
const getVariantProps = (variants) => ({ ...bannerDefaultVariants, ...compact(variants) })

export const banner = /* @__PURE__ */ Object.assign(bannerFn, {
  __recipe__: false,
  __name__: 'banner',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: bannerVariantKeys,
  variantMap: {
  "status": [
    "success",
    "info",
    "fatal",
    "error",
    "warning"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, bannerVariantKeys)
  },
  getVariantProps
})